import script from "./CourseLoader.vue?vue&type=script&setup=true&lang=ts"
export * from "./CourseLoader.vue?vue&type=script&setup=true&lang=ts"

import "./CourseLoader.vue?vue&type=style&index=0&id=452377c1&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-452377c1"]])

export default __exports__